import { api } from "./client";

export interface CryodeckBottle {
  id: number;
  bottle_issued_id: number;
  bottle_label_id: number;
  location: string | null;
}

export const cryodeckApi = {
  list: (deviceId: string, unlocatedOnly = false) =>
    api.get<{ bottles: CryodeckBottle[] }>(
      `/api/dashboard/devices/${deviceId}/cryodeck-bottles?unlocated=${unlocatedOnly}`,
    ),
  setLocation: (bottleId: number, location: string | null) =>
    api.patch<{ id: number; location: string | null }>(
      `/api/dashboard/cryodeck-bottles/${bottleId}`,
      { location },
    ),
};
